<template>
  <div>
    <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">老师管理系统</el-breadcrumb-item>
  <el-breadcrumb-item>学生管理</el-breadcrumb-item>
  <el-breadcrumb-item>学生成绩导入</el-breadcrumb-item>
</el-breadcrumb>
    </div>
    <el-card>
        <el-row>
  <el-col :span="20"><div class="grid-content bg-purple-dark"><el-input v-model="input" v-show="false" placeholder="请输入标题"></el-input></div></el-col>
    <el-col :span="2"><div class="grid-content bg-purple"> <el-button type="primary" v-show="false">查询</el-button></div></el-col>
  <el-col :span="2"><div class="grid-content bg-purple-light"> <el-button type="primary" @click="showVisible=true">添加</el-button></div></el-col>
   <el-col :span="3"> <p class="lableforSearch">查询到{{corectHeahList.length}}条数据</p></el-col>
  
</el-row>
 <el-table
    ref="multipleTable"
    :data="corectHeahList"
    tooltip-effect="dark"
    border
    show-overflow-tooltip="true"
    style="width: 100%"
    >
    <el-table-column
      prop="topic"
      label="题目"
      width="380"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="compositionNo"
      label="作文号"
      width="80"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="source"
      label="来源"
      width="80"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="beginDate"
      label="开始时间"
       width="170"
      show-overflow-tooltip>
    </el-table-column>
    <el-table-column
      prop="endDate"
      label="结束时间"
       width="170"
      show-overflow-tooltip>
    </el-table-column>
     <el-table-column
      label="操作"
      width="200">
        <template slot-scope="scope" >
<el-button   size="small" @click="deleteExcelByHeadId(scope.row)"><svg class="icon" aria-hidden="true">
  <use xlink:href="#icon-shanchu"></use>
</svg></el-button>
<el-button   size="small" @click="showExcelByHeadId(scope.row)"><svg class="icon" aria-hidden="true">
  <use xlink:href="#icon-chakan2"></use>
</svg></el-button>
      </template>
    </el-table-column>
  </el-table>

    </el-card>
    <el-dialog
     v-loading="loading"
  title="上传文件"
  :visible.sync="showVisible"
  width="30%"
 >
<!-- <el-form :model="addForm">
  <el-form-item prop="">
    </el-form-item>
</el-form> -->
  <el-upload
  class="upload-demo"
  action="https://jsonplaceholder.typicode.com/posts/"
  :on-preview="handlePreview"
   ref="upload"
  :on-remove="handleRemove"
  :before-remove="beforeRemove"
  :before-upload="handleBeforeUpload"
   multiple
  :limit="3"
  :on-error="handleUploadError"  
  :on-success="handleUploadSuccess"  
  :auto-upload="false"
  :on-exceed="handleExceed"
  :file-list="fileList"
  :on-change="changeFile"
  :http-request="httpRequest"
   accept=".xlsx,.xls"
 >
  <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
   <el-row>
   <el-col :span="5"><span class="span1">来源:</span></el-col>
  <el-col :span="15">
  <el-radio v-model="radio" label="批改网">批改网</el-radio>
  <el-radio v-model="radio" label="学习通">学习通</el-radio>
  <el-radio v-model="radio" label="成绩导入">成绩导入</el-radio>
  </el-col>
</el-row>
</el-upload>
 <span slot="footer" class="dialog-footer">
  <el-button type="primary" @click="insertExcel" :disabled="isDisable">提交</el-button>
    <el-button @click="showVisible = false">取 消</el-button>
  </span>
</el-dialog>
   <el-dialog
  :visible.sync="shouEarchts"
  v-if="shouEarchts"
  destroy-on-close
  width="100%"
  >
  <ViewExcelEcharts :coretchList="coretchList" :corectHeah="corectHeah"></ViewExcelEcharts>
  <span slot="footer" class="dialog-footer">
    <el-button @click="shouEarchts = false">取 消</el-button>
    <el-button type="primary" @click="shouEarchts = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import ViewExcelEcharts from '@/components/work/teacher/ViewExcelEcharts.vue'
import "@/components/work/until/icon/iconfont.js"
export default {
  components:{ViewExcelEcharts},
created(){
  this.getExcelList()
},
 data() {
      return {
        accept: '',
        loading: false,
        shouEarchts:false,
        action: 'action',
        input:"",
        radio:'',
        showVisible:false,
        fileList: [],
        file:'',
        isDisable: false,
        corectHeahList:[],
        coretchList:[],
        corectHeah:{}
      };
    },
    methods: {
      handleRemove(file,fileList) {
       this.file=file
       this.fileList=fileList 
      },
      getExcelList(){
         let config = {headers: { "Content-Type": "application/json" }};
          const formData = new FormData()
          formData.append("createTeacherid",JSON.parse(localStorage.getItem('user')).userid)
              this.axios.post("/excell/getCorrectheadByTeacherid",formData,config)
       .then(resp => {  
                      if(resp.data.status == 1) { 
                         console.log(resp.data.result)
                                   this.corectHeahList=resp.data.result                                                             
                                }else if(resp.data.status == 2){
          
                                  this.$message.error(resp.data.message)                     
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            })  
      },
      handlePreview(file) {
        console.log(file);
      },
         handleUploadSuccess(res, file) {
      this.$message.success("上传成功");
      this.cancel()
    },
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
    
      },showExcelByHeadId(data){
        
        this.axios.post("/excell/showExcelByHeadId","correctHeadId="+data.correctHeadId+"&source="+data.source)
       .then(resp => {  
                      if(resp.data.status == 1) { 
                        this.corectHeah=data
                         console.log(resp.data.result)
                            this.shouEarchts=true  
                           this.coretchList=resp.data.result
                                }else if(resp.data.status == 2){
                                  this.$message.error(resp.data.message)                     
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            })  
      },
      insertExcel(){
        if (this.fileList.length <= 0) {
          this.$message.success("请选择文件")
        return false
      }
      alert(this.fileList.length)
      this.isDisable = true
      setTimeout(() => { //防止重复提交
      this.isDisable = false
    }, 1000)

      this.$refs.upload.submit() 
      },
      deleteExcelByHeadId(data){
        const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/excell/deleteExcelByHeadId","correctHeadId="+data.correctHeadId+"&pathName="+data.pathName)
       .then(resp => {  
                      if(resp.data.status == 1) { 
                        that.$message.success("删除成功")
                        that.getExcelList()                                                      
                                }else if(resp.data.status == 2){
          
                                  that.$message.error(resp.data.message)                     
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            })  
      }).catch(()=>{});
      },
      handleBeforeUpload(file) { 

                if (!(file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                    this.$notify.warning({
                        title: '警告',
                        message: '请上传格式为.xlsx,.xls的文件'
                        
                    })
                    return false
                }
                let size = file.size / 1024 / 1024 / 2; 
                if (size > 2) {         
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于5M'
                    })
                    return false
                }

            },
             changeFile(file,fileList) {
              this.file=file
              this.fileList=fileList
               let size = file.size / 1024 / 1024 / 2; 
                if (size > 2) {                   
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于5M'
                    })
                   
                }
          
               
            },  
    
      httpRequest(param) {
          let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const formData = new FormData()
      formData.append("userid",JSON.parse(localStorage.getItem('user')).userid)
      formData.append('file', param.file)
      formData.append('radio', this.radio)
      this.axios.post("/excell/readExcellDemo",formData,config)
       .then(resp => {  
                      if(resp.data.status == 1) {   
                      this.showVisible=false
                         this.$message.success("上传成功")
                         console.log(resp.data)
                          this.getExcelList()  
                         if(resp.data.message!=null){
                           alert(resp.data.message)
                         }
                         this.$refs.upload.clearFiles()                                                                                                                    
                                }else if(resp.data.status == 2){
                                  alert('失败') 
                                  this.$message.error(resp.data.message)   
                                   this.$refs.upload.clearFiles()                     
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                alert("出错了")
                                console.log(err)
                            })            
    }}
  }
</script>

<style>
.radios{
  margin-top: 20px;
}
span1{
  margin: 20px;
}
.el-row{
  margin-top: 20px;
}
.icon {
  width: 1.2em;
  height: 1.2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
 .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/teacher/ReadExcell.vue